"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDuplicateModalCtrl = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var services_1 = require("../../services");
var store_1 = require("../../store");
var CollectionDuplicateModalCtrl = /** @class */ (function () {
    function CollectionDuplicateModalCtrl(collections) {
        this.duplicating = false;
        this.collections = collections;
    }
    //we take the departmentId as a parameter to make inter department duplication easier to implement even if it is not currently needed
    CollectionDuplicateModalCtrl.prototype.duplicateCollections = function (departmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionsByTag, _i, _a, collection, tagId, _b, _c, tagId, collectionGroup, tag;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.duplicating) {
                            return [2 /*return*/];
                        }
                        collectionsByTag = {};
                        for (_i = 0, _a = this.collections; _i < _a.length; _i++) {
                            collection = _a[_i];
                            tagId = collection.tags.find(function (t) { return !(0, core_api_1.isSystemTag)(t); });
                            if (collectionsByTag[tagId] != null) {
                                collectionsByTag[tagId].push(collection);
                            }
                            else {
                                collectionsByTag[tagId] = [collection];
                            }
                        }
                        this.setDuplicating(true);
                        _b = 0, _c = Object.keys(collectionsByTag);
                        _d.label = 1;
                    case 1:
                        if (!(_b < _c.length)) return [3 /*break*/, 6];
                        tagId = _c[_b];
                        collectionGroup = collectionsByTag[tagId];
                        tag = store_1.AppStore.Tag.get(tagId);
                        if (!(departmentId == null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, services_1.Services.Collection.duplicate(collectionGroup, tag.name)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, services_1.Services.Collection.duplicate(collectionGroup, tag.name, departmentId)];
                    case 4:
                        _d.sent();
                        _d.label = 5;
                    case 5:
                        _b++;
                        return [3 /*break*/, 1];
                    case 6:
                        this.setDuplicating(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionDuplicateModalCtrl.prototype.setDuplicating = function (duplicating) {
        this.duplicating = duplicating;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionDuplicateModalCtrl.prototype, "tagName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionDuplicateModalCtrl.prototype, "duplicating", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionDuplicateModalCtrl.prototype, "setDuplicating", null);
    return CollectionDuplicateModalCtrl;
}());
exports.CollectionDuplicateModalCtrl = CollectionDuplicateModalCtrl;
//# sourceMappingURL=collection.duplicate.modal.ctrl.js.map